import { IconButton, Menu, MenuItem } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import React, { useContext, useState } from 'react'
import { ThemeContext } from '../theme-context'
import _ from 'lodash'
import moment, { Moment } from 'moment'

const base64ZoomUrl = `aHR0cHM6Ly91czA1d2ViLnpvb20udXMvai85MzM0MTA5ODcwP3B3ZD1URWhVWnpKNFltVjZkRWhhZEZSak16QlBWMjV4ZHowOQ==`
const zoomUrl = Buffer.from(base64ZoomUrl, 'base64').toString('ascii')
const DAYS_ALLOWED_TO_EDIT_TARGETS = 3

const menuStyle: React.CSSProperties = {
  position: 'absolute',
  top: 10,
  right: 10,
}

export interface PassedDownProps {
  roundStartDay: Moment
  onLogout: () => void
}

interface Props extends PassedDownProps {
  onSendInvite: () => void
  onViewProfile: () => void
  onEditTargets: () => void
  onChangePassword: () => void
}

export const MiniMenu = ({
  roundStartDay,
  onSendInvite,
  onViewProfile,
  onEditTargets,
  onChangePassword,
  onLogout,
}: Props) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [isInDarkMode, toggleDarkMode] = useContext(ThemeContext)

  const handleOpenMenu = (e: React.BaseSyntheticEvent) => {
    setMenuAnchorEl(e.target)
    setMenuIsOpen(true)
  }

  const handleClose = () => {
    setMenuAnchorEl(null)
    setMenuIsOpen(false)
  }

  const closeMenuAndRunFunc = (actionFunc: Function) => {
    handleClose()
    actionFunc()
  }

  const daysIntoRound = moment().diff(roundStartDay, 'days')
  const daysLeftToEditTargets = DAYS_ALLOWED_TO_EDIT_TARGETS - daysIntoRound

  return (
    <div>
      <IconButton onClick={handleOpenMenu} style={menuStyle}>
        <MenuIcon />
      </IconButton>
      <Menu open={menuIsOpen} anchorEl={menuAnchorEl} onClose={handleClose}>
        <MenuItem onClick={() => closeMenuAndRunFunc(onSendInvite)}>🚀 Invite Someone!</MenuItem>
        <MenuItem onClick={onViewProfile}>🏆 View Profile</MenuItem>
        <MenuItem
          onClick={() => closeMenuAndRunFunc(onEditTargets)}
          disabled={daysLeftToEditTargets <= 0 && daysIntoRound !== 13}
        >
          {daysIntoRound === 13
            ? `🎯 Edit targets for next round`
            : `🎯 Edit Targets (${_.max([
                daysLeftToEditTargets,
                0,
              ])} days left)`}
        </MenuItem>
        <MenuItem onClick={() => toggleDarkMode()}>
          🌛 {isInDarkMode ? 'Turn off' : 'Turn on'} dark mode
        </MenuItem>
        <MenuItem onClick={() => window.open(zoomUrl, '_blank')}>
          ☎️ Zoom link
        </MenuItem>
        <MenuItem onClick={onChangePassword}>🙊 Change password</MenuItem>
        <MenuItem onClick={onLogout}>Logout</MenuItem>
      </Menu>
    </div>
  )
}
